/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Logo from "./partials/Logo";
import i18next, { t } from "i18next";
import { HashLink } from "react-router-hash-link";
import { IoMdArrowDropdown } from "react-icons/io";
import { IoClose } from "react-icons/io5";

const propTypes = {
  navPosition: PropTypes.string,
  hideNav: PropTypes.bool,
  hideSignin: PropTypes.bool,
  bottomOuterDivider: PropTypes.bool,
  bottomDivider: PropTypes.bool,
};

const defaultProps = {
  navPosition: "",
  hideNav: false,
  hideSignin: false,
  bottomOuterDivider: false,
  bottomDivider: false,
};

const Header = ({
  className,
  navPosition,
  hideNav,
  hideSignin,
  bottomOuterDivider,
  bottomDivider,
  ...props
}) => {
  const [isActive, setIsactive] = useState(false);
  const [projectsOpen, setProjectsOpen] = useState(false);
  const [langOpen, setLangOpen] = useState(false);

  const nav = useRef(null);
  const hamburger = useRef(null);

  useEffect(() => {
  document.addEventListener("keydown", keyPress);
  document.addEventListener("click", clickOutside);

  return () => {
    document.removeEventListener("keydown", keyPress);
    document.removeEventListener("click", clickOutside);
  };
}, []); // <- empty dependency array


  const openMenu = () => {
    document.body.classList.add("off-nav-is-active");
    setIsactive(true);
  };

  const closeMenu = () => {
    document.body.classList.remove("off-nav-is-active");
    nav.current && (nav.current.style.maxHeight = null);
    setIsactive(false);
    setProjectsOpen(false);
    setLangOpen(false);
  };

  const keyPress = (e) => {
    isActive && e.keyCode === 27 && closeMenu();
  };

  const clickOutside = (e) => {
    if (!nav.current) return;
    if (
      !isActive ||
      nav.current.contains(e.target) ||
      e.target === hamburger.current
    )
      return;
    closeMenu();
  };

  const classes = classNames(
    "site-header",
    bottomOuterDivider && "has-bottom-divider",
    className
  );

  return (
    <header {...props} className={classes}>
      <div className="container">
        <div
          className={classNames(
            "site-header-inner",
            bottomDivider && "has-bottom-divider"
          )}
        >
          <Logo />
          {!hideNav && (
            <>
              <button
                ref={hamburger}
                className="header-nav-toggle"
                onClick={isActive ? closeMenu : openMenu}
              >
                <span className="screen-reader">Menu</span>
                <span className="hamburger">
                  <span className="hamburger-inner"></span>
                </span>
              </button>
              <nav
  ref={nav}
  className={classNames("header-nav", isActive && "is-active")}
  onClick={(e) => e.stopPropagation()} // clicks inside nav don’t bubble
>

                <div className="header-nav-header">
                  <div className="menu-title">Menu</div>
                  <div className="logo-close">
                    <Logo />
                    <button className="header-nav-close" onClick={closeMenu}>
                      <IoClose />
                    </button>
                  </div>
                </div>
                <div className="header-nav-inner">
                  <ul
                    className={classNames(
                      "list-reset text-xs",
                      navPosition && `header-nav-${navPosition}`
                    )}
                  >
                    <li>
                      <HashLink smooth to="/#aboutUs" onClick={closeMenu}>
                        {t("AboutUs")}
                      </HashLink>
                    </li>
                    <li className="dropdown">
                      <button
  className="dropbtn"
  style={{ display: 'flex', alignItems: 'center' }}
  onClick={(e) => {
    e.stopPropagation(); // prevent bubbling to global click
    setProjectsOpen((prev) => !prev);
  }}
>
  {t("Projects")}
  <IoMdArrowDropdown />
</button>

                      
                      <div className={classNames("dropdown-content", projectsOpen && "is-open")}>
                        <HashLink smooth to="/projects" onClick={closeMenu}>
                          {t("References")} 
                        </HashLink>
                        
                        <HashLink smooth to="/upcoming-projects" onClick={closeMenu}>
                          {t("UpcomingProjects")}
                        </HashLink>
                      </div>
                    </li>
                    <li>
                      <HashLink smooth to="/ourTeam" onClick={closeMenu}>
                        {t("OurTeam")}
                      </HashLink>
                    </li>
                    <li>
                      <HashLink smooth to="/#contact" onClick={closeMenu}>
                        {t("Contact")}
                      </HashLink>
                    </li>
                    <div className="dropdown">
                      <button 
  className="dropbtn" 
  onClick={(e) => {
    e.stopPropagation();
    setLangOpen((prev) => !prev);
  }}
>
  {i18next.language === "de" ? "DE" : "EN"}
  <IoMdArrowDropdown />
</button>

                      <div className={classNames("dropdown-content", langOpen && "is-open")}>
                        <a
                          href={void 0}
                          onClick={() => i18next.changeLanguage("en")}
                        >
                          EN
                        </a>
                        <a
                          href={void 0}
                          onClick={() => i18next.changeLanguage("de")}
                        >
                          DE
                        </a>
                      </div>
                    </div>
                  </ul>
                </div>
              </nav>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

export default Header;